import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

// ── Tune the typewriter here ────────────────────────────────────────────
// Same word list RollingWord.js rolls through (that component is kept
// around, unused, in case this gets swapped back later) — just without the
// trailing duplicate "Days", which only existed there to make its
// scroll-back-to-start jump land on an already-visible word.
const WORDS = [
  "Days",
  "Moments",
  "Memories",
  "Weeks",
  "Connections",
  "Adventures",
  "Seasons",
  "Conversations",
  "Months",
  "Years",
  "Lives",
];

const TYPE_LETTER_MS = 70; // delay between each revealed letter
const HOLD_MS = 1200; // how long the fully-typed word sits before fading
const FADE_OUT_MS = 450; // duration of the whole-word fade-out
const GAP_MS = 200; // pause after a word fades before the next starts typing
// ─────────────────────────────────────────────────────────────────────────

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default function TypewriterWord({ className = "" }) {
  const [word, setWord] = useState(WORDS[0]);
  const [typedCount, setTypedCount] = useState(0);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let wordIndex = 0;

    const runCycle = async () => {
      while (!cancelled) {
        const currentWord = WORDS[wordIndex];
        setWord(currentWord);
        setIsFadingOut(false);
        setTypedCount(0);

        for (let i = 1; i <= currentWord.length; i++) {
          if (cancelled) return;
          await sleep(TYPE_LETTER_MS);
          if (cancelled) return;
          setTypedCount(i);
        }

        if (cancelled) return;
        await sleep(HOLD_MS);
        if (cancelled) return;

        setIsFadingOut(true);
        await sleep(FADE_OUT_MS + GAP_MS);
        if (cancelled) return;

        wordIndex = (wordIndex + 1) % WORDS.length;
      }
    };

    runCycle();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <motion.span
      className={`typewriter-word ${className}`}
      animate={{ opacity: isFadingOut ? 0 : 1 }}
      transition={{ duration: FADE_OUT_MS / 1000, ease: "easeOut" }}
    >
      {word.slice(0, typedCount)}
      <span className="typewriter-cursor" aria-hidden="true" />
    </motion.span>
  );
}
